import request from "@/utils/request"
// 新闻页
export let indexJson = () => {
    return request({
        url: "/portal/index/indexJson",
        method: "GET",
    })
}
// 首页轮播图
export let banner = () => {
    return request({
        url: "/portal/index/banner",
        method: "GET",
    })
}
// 图书类型
export let bookTypeList = () => {
    return request({
        url: "portal/books/bookTypeList",
        method: "GET",
    })
}
// 图书列表
export let booksList = (data) => {
    return request({
        url: "/portal/books/pageList",
        method: "POST",
        params: data
    })
}
// 图书详情
export let bookDetail = (data) => {
    return request({
        url: "/portal/books/bookDetail",
        method: "POST",
        params: data
    })
}
// 期刊列表
export let journalsList = (data) => {
    return request({
        url: "/portal/journals/journalsList",
        method: "POST",
        params: data
    })
}
// Payment 页面书名获取
export let getProductList = (data) => {
    return request({
        url: "/portal/page/getProductList",
        method: "POST",
        params: data
    })
}
//新闻列表
export let newsList = (data) => {
    return request({
        url: "portal/list/newsList",
        method: "POST",
        params: data
    })
}
//新闻详情
export let newsDetail = (data) => {
    return request({
        url: "portal/list/newsDetail",
        method: "POST",
        params: data
    })
}
//apc Payment支付接口
export let apcPaymentCreateOrder = (data) => {
    return request({
        url: "portal/page/apcPaymentCreateOrder",
        method: "POST",
        params: data
    })
}
//books生成订单
export let createBooksOrderInfo = (data) => {
    return request({
        url: "portal/page/createBooksOrderInfo",
        method: "POST",
        params: data
    })
}
//books订单支付状态检查
export let checkBooksOrder = (data) => {
    return request({
        url: "portal/page/checkBooksOrder",
        method: "POST",
        params: data
    })
}
//会议接口
export let conferenceDataList = (data) => {
    return request({
        url: "portal/Conference/dataList",
        method: "POST",
        params: data
    })
}
// 会议详情接口
export let conferenceDetailInfo = (data) => {
    return request({
        url: "portal/Conference/detailInfo",
        method: "POST",
        params: data
    })
}
//查询接口 
export let searchList = (data) => {
    return request({
        url: "portal/index/searchList",
        method: "POST",
        params: data
    })
}

//特刊列表接口
export let publicationList = (params) => {
    return request({
        url: "portal/publication/list/id",
        method: "GET",
        params
    })
}

//特刊详情
export let publicationInfo = (id) => {
    return request({
        url: `portal/publication/info/id/${id}`,
        method: "GET",
    })
}





// WEBPACK FOOTER //
// ./src/api/link.js